<terra-dialog-header>
  <mat-icon *ngIf="data.icon" class="icon" [ngClass]="data.iconClass">{{
    data.icon
  }}</mat-icon>
  <h1 [innerHTML]="data.title"></h1>
</terra-dialog-header>

<mat-dialog-content>
  <div class="description" [innerHTML]="data.description | safeHtml"></div>
</mat-dialog-content>

<div *ngIf="data.showAction" mat-dialog-actions [ngClass]="data.actionPosition">
  <button
    mat-flat-button
    [mat-dialog-close]="undefined"
    color="primary"
    cdkFocusInitial
    class="action-button"
  >
    {{ data.actionLabel || "OK" }}
  </button>
</div>
